import React, { useEffect, useState } from "react";
import styles from "./BusinessDetails.module.scss";
import NavBar from "../../components/navbar/NavBar";
import FilterModal from "../../components/filterConfig/FilterModal";
import dayjs, { Dayjs } from "dayjs";
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from "../../util/datefunction";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import axios from "axios";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import {
	openModalAndSetContent,
	closeModal,
} from "../../redux/actions/modal/modalActions";
import {
	BusinessUserModuleData,
	ColumnBusinessUserModule,
} from "../../types/BusinessModule";
import PaginationTable from "../../components/paginatedTable/pagination-table";
import TableHeader from "../../components/TableHeader/TableHeader";
import StatusView from "../../components/StatusView/StatusView";
import { useHistory, useParams } from "react-router-dom";

function User() {
	const { id } = useParams<any>();

	const [tableRow, setTableRow] = useState<any[]>();
	const [businesses, setBusinesses] = useState<any>();
	const [contentAction, setContentAction] = useState<any>({});
	const history = useHistory();

	const dispatch = useDispatch();
	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	//FILTERING
	const [value, setValue] = useState("");
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState("");
	const [fromDate, setFromDate] = useState<Dayjs | null | string>("");
	const [toDate, setToDate] = useState<Dayjs | null | string>("");
	const [country, setCountry] = useState("");
	const [status, setStatus] = useState("");
	const [email, setEmail] = useState("");

	const [bearer, setBearer] = useState(false);

	const clearHandler = () => {
		setEventDate("");
		setFromDate("");
		setToDate("");
		setCountry("");
		setStatus("");
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === "today") {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === "last7days") {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "last30days") {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "oneyear") {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate("");
			setToDate("");
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: "Status",
			value: status,
			setValue: setStatus,
			selective: [{ name: "YES" }, { name: "NO" }],
		},
	];

	const fetchBusinesses = async () => {
		dispatch(openLoader());
		setLoading(true);
		try {
			const data = await axios.get(
				`/v1/business/${id}/users?status=${status}&date=${toDate}&search=${value}&perpage=${rowsPerPage}&page=${pageNumber}`
			);
			setBearer(false);
			setBusinesses(data?.data);
			dispatch(closeLoader());
			setLoading(false);
		} catch (error: any) {
			setLoading(false);
			dispatch(closeLoader());
			const message = error?.response?.data?.message;
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastType: "error",
					})
				)
			);
		}
	};

	useEffect(() => {
		fetchBusinesses();
	}, [bearer, value, pageNumber, rowsPerPage]);

	useEffect(() => {
		setPageNumber(businesses?._metadata?.page || 1);
	}, [businesses]);

	const reset2faHandler = (userId: number) => {
		dispatch(openLoader());

		axios
			.post(`/v1/business/${id}/users/${userId}/reset-2fa`)
			.then((res: any) => {
				dispatch(closeLoader());
				dispatch(closeModal());
				setBearer(true);

				dispatch(
					openToastAndSetContent({
						toastContent: res?.data?.message,
						toastType: "success",
					})
				);
			})
			.catch((err: any) => {
				dispatch(closeLoader());
				dispatch(closeModal());
				dispatch(
					openToastAndSetContent({
						toastContent:
							err?.response?.data?.message || "Unable to reset 2FA",
						toastType: "error",
					})
				);
			});
	};

	const confirmReset2fa = (userId: number, email: string) => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
					maxWidth: "420px",
					width: "100%",
				},
				modalContent: (
					<div style={{ padding: "24px" }}>
						<h1 style={{ fontSize: "18px", margin: "0 0 12px" }}>Reset 2FA</h1>
						<p
							style={{
								fontSize: "14px",
								lineHeight: 1.5,
								margin: "0 0 20px",
							}}>
							This clears the authenticator for <strong>{email}</strong>. They
							will set up a new one the next time they log in, and their
							current codes stop working. Only do this once you are sure who
							you are speaking to.
						</p>
						<div
							style={{
								display: "flex",
								gap: "12px",
								justifyContent: "flex-end",
							}}>
							<button
								onClick={() => dispatch(closeModal())}
								style={{
									background: "#E0E0E0",
									color: "#333333",
									border: "none",
									borderRadius: "4px",
									padding: "10px 20px",
									cursor: "pointer",
								}}>
								Cancel
							</button>
							<button
								onClick={() => reset2faHandler(userId)}
								style={{
									background: "#27AE60",
									color: "#ffffff",
									border: "none",
									borderRadius: "4px",
									padding: "10px 20px",
									cursor: "pointer",
								}}>
								Reset
							</button>
						</div>
					</div>
				),
			})
		);
	};

	const dataBusinesses = () => {
		const tempArr: BusinessUserModuleData[] = [];
		businesses?.businessUsers
			?.slice(0)
			.reverse()
			.forEach((business: any, index: number) => {
				return tempArr.push({
					firstname: business.firstname,
					lastname: business.lastname,
					email: business.email,
					bvn: business.bvn,
					phonenumber: business.phonenumber,
					country: business.country,
					twofa: business?.twofaSetup ? "Enabled" : "Not set up",
					action: business?.twofaSetup ? (
						<button
							onClick={() =>
								confirmReset2fa(business.merchantaccountuserid, business.email)
							}
							style={{
								background: "none",
								border: "1px solid #27AE60",
								color: "#27AE60",
								borderRadius: "4px",
								padding: "6px 12px",
								cursor: "pointer",
								whiteSpace: "nowrap",
							}}>
							Reset 2FA
						</button>
					) : (
						"-"
					),
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataBusinesses());
	}, [businesses?.businessUsers]);

	if (loading) {
		return <div />;
	}
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name="Users" />
			<div className={styles.containerBusiness}>
				<div className={styles.containerHeader}>
					<TableHeader
						pageName=""
						data={businesses?.businessUsers}
						dataLength={businesses?._metadata.totalcount}
						value={value}
						setValue={setValue}
						dropdown={dropdown}
						setDropdown={setDropdown}
						placeHolder="Search"
						FilterComponent={
							<FilterModal
								eventDate={eventDate}
								setEventDate={setEventDate}
								dropdown={dropdown}
								setDropdown={setDropdown}
								setFromDate={setFromDate}
								setToDate={setToDate}
								fromDate={fromDate}
								toDate={toDate}
								setBearer={setBearer}
								clearHandler={clearHandler}
								filteredArray={filteredArray}
							/>
						}
					/>

					<PaginationTable
						data={tableRow ? tableRow : []}
						columns={ColumnBusinessUserModule ? ColumnBusinessUserModule : []}
						emptyPlaceHolder={
							businesses?._metadata?.totalcount == 0
								? "No record found"
								: "Loading..."
						}
						value={value}
						total={businesses?._metadata.totalcount}
						totalPage={businesses?._metadata.pagecount}
						pageNumber={pageNumber}
						setPageNumber={setPageNumber}
						nextPage={nextPage}
						setNextPage={setNextPage}
						previousPage={previousPage}
						setPreviousPage={setPreviousPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						clickAction={false}
						setContentAction={setContentAction}
					/>
				</div>
			</div>
		</div>
	);
}

export default User;
